import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "reactstrap";
import CustomReactQuillDescription from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import RentProductSubmitRequestPopup from "./RentProductSubmitRequestPopup";
import {
  addtowishRentalbyid,
  getRentalById,
} from "../../../../redux/rental/action";
import { Commas } from "../../../Common/AllDateTimeReleventFormate";
import Access from "../../../CustomComponents/Access/Access";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useRouteBaseStateContext } from "../../../../Context/RouteBaseStateContext";
import { IS_LOGGED_IN_USER } from "../../../../assests/extention/commonfunction";
import ReactImageGalleryCompoment from "../SearchContestParticipate/ContestDetails/ReactImageGalleryCompoment";

export default function RentProductDetails() {
  const [modaltitle, setModaltitle] = useState(false);
  const [modal, setModal] = useState(false);
  const [images, setImages] = useState([]);
  const dispatch = useDispatch();
  const { id } = useParams();
  const navigate = useNavigate();
  const { setOTSroute } = useRouteBaseStateContext();

  const laung = localStorage.getItem("laung");
  const lan = laung ?? "en";
  const path = "Assets/scss/FindWork.module.scss";

  const getrentalbyid = useSelector(
    ({ rental: { getrentalbyid } }) => getrentalbyid
  );

  useEffect(() => {
    LoadCSSforfirstTime(path);
    dispatch(getRentalById(id));
  }, [id]);

  useEffect(() => {
    if (getrentalbyid && Array.isArray(getrentalbyid.files)) {
      const formattedImages = getrentalbyid.files.map((f) => ({
        original: f.file,
        thumbnail: f.file,
      }));
      setImages(formattedImages);
    } else if (getrentalbyid?.cover) {
      setImages([{ original: getrentalbyid.cover, thumbnail: getrentalbyid.cover }]);
    }
  }, [getrentalbyid]);

  const openmymodel = () => setModaltitle(!modaltitle);
  const checkaccessss = () => setModal(!modal);

  const addtowishlist11 = (id) => dispatch(addtowishRentalbyid(id));

  const handleNavigateToOTS = () => {
    navigate(`/${lan}/dashboard/myotsproducts?rentproid=${id}`);
    setOTSroute("RentalProducts");
  };

  return (
    <div className="col-lg-10 mx-auto project-details packageddetails">
      {modal && (
        <Access
          modal={modal}
          setModal={setModal}
          state={"state"}
          checkpermission={"request_rental"}
          hitmethod={openmymodel}
          masterID={getrentalbyid?.id}
          checkrole={false}
        />
      )}

      <p className="breadcrumbs">
        <a onClick={() => navigate(`/${laung}/searchrentproducts`)}>TAI &gt; </a>
        {getrentalbyid?.title}
      </p>

      <div className="col-lg-10 mx-auto">
        <div className="row">
          <div className="col-md-6">
            <ReactImageGalleryCompoment images={images} />
          </div>

          <div className="col-md-6 package-right">
            <h3>{getrentalbyid?.title}</h3>
            <div className="price-duration">
              {
                getrentalbyid?.rental_only == 1 &&
                <div>
                  <h6>Rental Price</h6>
                  <h2>
                    SAR {getrentalbyid?.price}/
                    {getrentalbyid?.price_type == 1
                      ? "hour"
                      : getrentalbyid?.price_type == 2
                        ? "day"
                        : getrentalbyid?.price_type == 3
                          ? "weeks"
                          : "months"}
                  </h2>
                </div>
              }

              {getrentalbyid?.rental_with_interpreter == 1 && (
                <div>
                  <h6>
                    Rental with Interpreter
                  </h6>
                  <h2>
                    SAR {Commas(getrentalbyid?.price_interpreter)}/
                    {getrentalbyid?.price_type_interpreter == 1
                      ? "Hour"
                      : getrentalbyid?.price_type_interpreter == 2
                        ? "Days"
                        : getrentalbyid?.price_type_interpreter == 3
                          ? "Weeks"
                          : "Months"}
                  </h2>
                </div>
              )}
            </div>

            <div className="price-duration">
              <div>
                <h6>Industry</h6>
                <h2>{getrentalbyid?.industry_title}</h2>
              </div>
              <div>
                <h6>Category</h6>
                <h2>{getrentalbyid?.category_title}</h2>
              </div>
              {getrentalbyid?.sub_category_title && (
                <div>
                  <h6>Sub - category</h6>
                  <h2>{getrentalbyid?.sub_category_title}</h2>
                </div>
              )}
            </div>

            <div className="price-duration flex-column align-items-start">
              <h6>Description</h6>
              <CustomReactQuillDescription value={getrentalbyid?.description} />
            </div>

            <div className="d-flex align-items-center" style={{ columnGap: "15px" }}>
              {getrentalbyid?.is_mine == 1 ? (
                <button
                  className="btn purchase-btn w-100"
                  onClick={handleNavigateToOTS}
                >
                  View details
                </button>
              ) : (
                <button
                  className="btn purchase-btn w-100 mt-4"
                  onClick={checkaccessss}
                  disabled={getrentalbyid?.rental_request_id}
                >
                  {getrentalbyid?.rental_request_id ? "Request Sent" : "Send Rental Request"}
                </button>
              )}
              <button
                className="btn heart-btn mt-4"
                style={{ background: "transparent", padding: "0" }}
                onClick={() => {
                  if (IS_LOGGED_IN_USER) {
                    addtowishlist11(getrentalbyid?.id);
                  } else {
                    setModal(true);
                  }
                }}
              >
                <img
                  src={
                    getrentalbyid.wishlist == 1
                      ? `${CloudStorage.cloudurl}/Assets/Images/project/heart-active.svg`
                      : `${CloudStorage.cloudurl}/Assets/Images/project/heart.svg`
                  }
                  alt="wishlist"
                />
              </button>
            </div>
          </div>
        </div>
      </div>

      <Modal
        className="popupmodal rent-modal"
        isOpen={modaltitle}
        toggle={() => setModaltitle(!modaltitle)}
        backdrop="static"
        keyboard={false}
      >
        <RentProductSubmitRequestPopup
          data={getrentalbyid}
          setModaltitle={setModaltitle}
        />
      </Modal>

    </div>
  );
}
